// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2444":"91189d4d","7889":"91189d4d"}[chunkId] + ".chunk.css";
};